/**
 * beaut-627: a product's fixed amount and percent are alternatives, not a sum.
 * Which of the two salary fields stays editable, given their current values.
 * The percent wins when both are set — the rule the backend applies.
 * Without an employee there is nobody to pay, so both are locked.
 */
export function salaryFieldLock(
  salaryFixed: number | string | null | undefined,
  salaryPercent: number | string | null | undefined,
  hasEmployee = true
): { lockFixed: boolean; lockPercent: boolean } {
  if (!hasEmployee) {
    return { lockFixed: true, lockPercent: true };
  }
  const hasPercent = +(salaryPercent ?? 0) > 0;
  const hasFixed = !hasPercent && +(salaryFixed ?? 0) > 0;
  return { lockFixed: hasPercent, lockPercent: hasFixed };
}
